import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicTabsService } from 'src/app/dynamic-tabs.service';
import { RefreshDialogComponent } from 'src/app/dialogs/refresh-dialog/refresh-dialog.component';
import { HomeService } from 'src/app/services/homeservice';
import { Idropdown, IHome } from 'src/app/sidenav/helper';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-policy-addnew',
  templateUrl: './addnew.component.html',
  styleUrls: ['./addnew.component.css']
})
export class AddnewComponent implements OnInit {
  @Input() IsHomeClicked: boolean = false;
  @Output() openDetailTab = new EventEmitter();
  savingData: boolean = false;
  addData: IHome = new IHome();
  response: IHome = new IHome();
  insured!: Idropdown[];
  polTy!: Idropdown[];
  polS!: Idropdown[];
  assnType!: string;
  @Input() label: string = '';

  constructor(private service: HomeService,
    private dialog: MatDialog,
    private dynamicTabService: DynamicTabsService,
    private cdRef: ChangeDetectorRef
  ) { }
  ngOnInit(): void {
    // this.getMasterPolicyAddData();
    this.getAccData();
    this.getDropPolTy();
    this.getDropPolS();
    this.dynamicTabService.saveObv.subscribe(value => {
      if (value && this.dynamicTabService.selectedTabData && this.dynamicTabService.selectedTabData.routerLink == 'policyAddNew')
        this.savePolicy();
    })
    this.dynamicTabService.refreshObv.subscribe(value => {
      if (value && this.dynamicTabService.selectedTabData && this.dynamicTabService.selectedTabData.routerLink == 'policyAddNew'&& (this.addData.id == undefined && !this.addData.id ))
        this.refresh();
    })
    //closeTab
    this.dynamicTabService.closeObv.subscribe(value => {
      if (value && this.dynamicTabService.closableTab && this.dynamicTabService.closableTab.routerLink == 'policyAddNew' && sessionStorage.getItem("closeBtn") == "true")
        this.closeTab();
    })

  }

  getAccData() {
    let insured = this.service.getDropdownAcc().subscribe((res: Idropdown[]) => {
      this.insured = res;
      // console.log(this.insured);
      this.dynamicTabService.sortDropdownData(this.insured, item => item.name);
    })
  }
  getDropPolTy() {
    let polTy = this.service.getDropdownPolT().subscribe((res: Idropdown[]) => {
      this.polTy = res;
      // console.log(this.polTy);
      this.dynamicTabService.sortDropdownData(this.polTy, item => item.name);
    })
  }
  getDropPolS() {
    let polS = this.service.getDropdownPolS().subscribe((res: Idropdown[]) => {
      this.polS = res;
      // console.log(this.polS);
      this.dynamicTabService.sortDropdownData(this.polS, item => item.name);
    })
  }
  openpolicy(addData: any) {
    this.openDetailTab.emit({ id: addData.id, label: addData.policyNumber + '-policy', type: 'policy' });
    return true;
    // console.log(addData);
  }
  savePolicy() {
    if (sessionStorage.getItem('saveBtn') == 'true' && (this.addData.id == undefined && !this.addData.id ) && this.dynamicTabService.selectedTabData.id == -10) {
      if (this.addData.accountID != null) {
        sessionStorage.setItem('saveBtn', 'false');
        this.service.getaddOrUpdatePolicy(this.addData).subscribe((res: IHome) => {
          this.response = res;
          this.addData.id =this.response.id;
          // var c = this.dynamicTabService.tabs.find(t=> t.id==this.dynamicTabService.closeTabId)
          // if(c!=null && c.closable)
          // this.dynamicTabService.removeTab(c);
          // this.sendIdToDetails(+this.response.accountID)   
          sessionStorage.setItem('saveBtn', 'false');
          const currentTablabel = this.dynamicTabService.selectedTab;
          const cTab =this.dynamicTabService.selectedTabData;
          if (this.openpolicy(this.response)) {
            this.savingData = true;
            if (this.dynamicTabService?.closableTab?.closable == true)
              this.dynamicTabService.removeTab(this.dynamicTabService.closableTab);
            else {
              // var cTab = this.dynamicTabService.tabs.find(t => t.label = currentTablabel);
              // var cTab = this.dynamicTabService.selectedTabData;
              if (cTab)
                this.dynamicTabService.removeTab(cTab);
            }
            // console.log(this.response);
          }
        })

      }

    }
    setTimeout(() => {
      //After data is saved,set savingdata back to false to hide the spinner
      this.savingData = false;
    }, 2000);
  }
  closeTab() {

    if (sessionStorage.getItem("closeBtn") == "true"  && (this.addData.id == undefined && !this.addData.id )) {
      this.dynamicTabService.tabs.filter(tab => tab.isActive = false);
      this.dynamicTabService.closableTab.isActive = true;
      const dialogRef = this.dialog.open(RefreshDialogComponent, {
        data: { message: 'closing?Closing' },
      });
      if (dialogRef.afterOpened())
        sessionStorage.setItem('closeBtn', 'false');
      const i = sessionStorage.getItem('closeBtn');
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'save') {
          sessionStorage.setItem('saveBtn', 'true');
          this.savePolicy();

        }
        else if (result === 'discard') {
          this.dynamicTabService.closeTab(this.dynamicTabService.closableTab);
          sessionStorage.setItem('closeBtn', 'false')
        }
      });
    }
  }
  refresh() {
    if (sessionStorage.getItem('refreshBtn') == 'true' && this.dynamicTabService.selectedTabData.id == -10) {

      if (Object.keys(this.addData).length > 0) {
        const dialogRef = this.dialog.open(RefreshDialogComponent, {
          data: { message: 'refreshing?Refreshing' },
        });
        if (dialogRef.afterOpened())
          sessionStorage.setItem('refreshBtn', 'false')

        dialogRef.afterClosed().subscribe(result => {
          if (result === 'save') {
            sessionStorage.setItem('saveBtn', 'true');
            this.savePolicy();
            sessionStorage.setItem('refreshBtn', 'false');
          }
          else if (result === 'discard') {
            this.addData = new IHome();
            this.response = new IHome();
            this.cdRef.detectChanges();
            sessionStorage.setItem('refreshBtn', 'false');
            // console.log("Masterpolicies addnew refreshed");
          }
        });

      }
      else {
        this.savingData = true;
        this.addData = new IHome();
        this.response = new IHome();
        this.cdRef.detectChanges();
        sessionStorage.setItem('refreshBtn', 'false');

        // console.log("Masterpolicies without any changes in addnew refreshed");
        setTimeout(() => {
          this.savingData = false;
        }, 2000);
      }

    }

  }

}
